import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { LifecycleManaging } from '../../../../abstract/lifecycle-managing';
import { filter, map, startWith, takeUntil, tap } from 'rxjs/operators';
import * as moment from 'moment';
import { merge } from 'rxjs';
import { DateUtils } from '../../../../utils/date.utils';
import { ObjectUtils } from 'src/app/shared/utils/object.utils';

@Component({
  selector: 'days-until-date',
  templateUrl: './days-until-date.component.html',
  styleUrls: ['./days-until-date.component.scss']
})
export class DaysUntilDateComponent extends LifecycleManaging implements OnInit {

  @Input() dateControlTo = new UntypedFormControl();
  @Input() dateControlFrom = new UntypedFormControl();
  @Input() daysId: string;
  @Input() placeholder: string;
  @Input() editMode: boolean;

  daysUntilControl = new UntypedFormControl();

  constructor() {
    super();
  }

  ngOnInit() {
    this.setUpValueListeners();
  }

  private setUpValueListeners() {
    merge(
      this.dateControlTo.valueChanges.pipe(map(val => [val, this.dateControlFrom.value])),
      this.dateControlFrom.valueChanges.pipe(map(val => [this.dateControlTo.value, val]))
    ).pipe(
      startWith([this.dateControlTo.value, this.dateControlFrom.value]),
      filter(([dateTo, dateFrom]) => dateTo != null && dateFrom != null),
      map(([dateTo, dateFrom]) => moment(dateTo).diff(moment(dateFrom).startOf('day'), 'days')),
      tap(days => this.daysUntilControl.setValue(days < 0 ? 0 : days, { emitEvent: false })),
      takeUntil(this.destroySubject)
    ).subscribe();

    this.daysUntilControl.valueChanges
      .pipe(
        tap(val => this.dateControlTo.setValue(moment(this.dateControlFrom.value).add(val, 'days'), { emitEvent: false })),
        takeUntil(this.destroySubject)
      )
      .subscribe();
  }

  getTranslateParams(full: boolean = false): string {
    const params: any = {
      amount: this.daysUntilControl.value || 0
    };

    if (full) {
      params.dateUntil = DateUtils.serializeDateWithoutTimeZone(this.dateControlTo.value);
      if (ObjectUtils.isEmpty(params.dateUntil)) {
        params.dateUntil = '';
      }
    }

    return params;
  }
}
